// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3jHFU","colMaxWidth":"Table_colMaxWidth__2-MN8"};